(function () {
  angular.module("akitabox.core.services.bannerMessage", [
    "akitabox.constants",
    "akitabox.core",
    "akitabox.core.services.http",
    "akitabox.core.lib.markdown",
  ]);
})();
